import React, { FC } from 'react';

import { CarouselYearCards } from '@bumble/ui-kit';
import lexemes from 'components/lexemes/page-about';

export const AboutOurStoryContainer: FC = () => {
  return (
    <CarouselYearCards
      title={lexemes.lxPageAboutOurStoryTitle}
      description={lexemes.lxPageAboutOurStoryDescription}
      scrollText={lexemes.lxPageAboutOurStoryScrollText}
      a11yScrollRightText={lexemes.lxPageAboutOurStoryScrollRightText}
      a11yScrollLeftText={lexemes.lxPageAboutOurStoryScrollLeftText}
      cards={[
        {
          year: 2014,
          title: lexemes.lxPageAboutOurStoryCard1Title,
          description: lexemes.lxPageAboutOurStoryCard1Description,
        },
        {
          year: 2016,
          title: lexemes.lxPageAboutOurStoryCard2Title,
          description: lexemes.lxPageAboutOurStoryCard2Description,
        },
        {
          year: 2019,
          title: lexemes.lxPageAboutOurStoryCard3Title,
          description: lexemes.lxPageAboutOurStoryCard3Description,
        },
        {
          year: 2020,
          title: lexemes.lxPageAboutOurStoryCard4Title,
          description: lexemes.lxPageAboutOurStoryCard4Description,
        },
        {
          year: 2021,
          title: lexemes.lxPageAboutOurStoryCard5Title,
          description: lexemes.lxPageAboutOurStoryCard5Description,
        },
        {
          year: 2022,
          title: lexemes.lxPageAboutOurStoryCard6Title,
          description: lexemes.lxPageAboutOurStoryCard6Description,
        },
        {
          year: 2024,
          title: lexemes.lxPageAboutOurStoryCard7Title,
          description: lexemes.lxPageAboutOurStoryCard7Description,
        },
        {
          year: 2025,
          title: lexemes.lxPageAboutOurStoryCard8Title,
          description: lexemes.lxPageAboutOurStoryCard8Description,
        },
      ]}
    />
  );
};
